/**
 * Console's idle clock and draft store.
 *
 * One clock per app, built once at module load, shared by everything in the
 * app. Building a second one would give the tab two timers reading the same
 * cookie and two chances to claim the sign-out.
 *
 * The cookie is scoped to samsurveyor.com wherever that is allowed, so Console,
 * Designer, Explorer and Channels all read and write the same clock. Working in
 * any one of them keeps the others signed in. On localhost the cookie is scoped
 * to this host instead, because a page cannot write a cookie for a domain it is
 * not on.
 */

// Deep paths on purpose. The `@cloudsam/ui` index pulls in AppShell, Panel,
// Button and the rest, so anything importing this file would drag the whole
// component set into its import graph. These modules are plain JavaScript with
// no React in them.
import { createIdleClock } from '@cloudsam/ui/dist/idle/idleClock';
import { createDraftStore } from '@cloudsam/ui/dist/idle/draftStore';
import { sessionCookieDomain } from '@cloudsam/ui/dist/idle/cookieDomain';
import { createHeartbeatSender } from '@cloudsam/ui/dist/idle/heartbeat';

/** How long a person may be idle before the session ends. */
export const IDLE_LOCK_MINUTES = 30;

export const idleClock = createIdleClock({
    cookiePrefix: 'sam',
    cookieDomain: sessionCookieDomain(),
    // Tells sam-dbam a person is here, so it can enforce the same 30 minutes on
    // its own. The browser timer only runs while a browser is running; close a
    // laptop at minute five and nothing revokes anything.
    //
    // Console goes through its own server, the way /api/console/me and
    // /api/console/signout already do. The other apps call dbam directly.
    onHeartbeat: createHeartbeatSender({ url: '/api/console/heartbeat' }),
});

export const draftStore = createDraftStore();

export default idleClock;
